module.exports = __webpack_public_path__ + "static/img/ability-icon2.fa0bce6.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/ability-icon2.png
// module id = ddiA
// module chunks = 1